import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, Form, Row, Col, Spinner, } from "react-bootstrap";
import Select from 'react-select';
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const ProductCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [description, setdescription] = useState("");
  const [partno, setPartno] = useState("");
  const [labourcharges, setlabourcharges] = useState("");
  const [hsnsacno, setHsnsacno] = useState("");
  const [igst, setIgst] = useState("");
  const [cgst, setCgst] = useState("");
  const [sgst, setSgst] = useState("");
  const [moc, setmoc] = useState("");
  const [brand, setBrand] = useState(null);
  const [isBrandSelected, setIsBrandSelected] = useState(false);
  const [brandOptions, setBrandOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fileInputs, setFileInputs] = useState([]);
  const [producttype, setproducttype] = useState('');
  const [unitofmeasurement, setunitofmeasurement] = useState("");
  const [itemcode, setitemcode] = useState("");
  const [modelnumber, setmodelnumber] = useState('');
  const [tagnumber, settagnumber] = useState('');
  ///
  const [outsidedia, setoutsidedia] = useState('');
  const [wallthickness, setwallthickness] = useState('');
  const [innerdia, setinnerdia] = useState('');
  // tubing row material 
  const [hardness, sethardness] = useState('');
  const [make, setmake] = useState('');
  // manufaturing row material 
  const [size, setsize] = useState('');
  const [schedule, setschedule] = useState('');
  const [classes, setclasses] = useState('');
  const [rating, setrating] = useState('');
  const [type, settype] = useState('');


  const [serialnumber, setserialnumber] = useState('');
  const [productcategory, setproductcategory] = useState('');
  const [customername, setcustomername] = useState('');
  const [group, setgroup] = useState(null);
  const [groupOptions, setgroupOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [customer, setcustomer] = useState(null);
  const [customerOptions, setcustomerOptions] = useState([]);

  const allProductTypes = [
    { value: "Raw Material", label: "Raw Material" },
    { value: "Semi Finished", label: "Semi Finished" },
    { value: "Finished", label: "Finished" },
    { value: "Services", label: "Services" },
  ];


  const capitalizeAllWords = (text) => {
    if (!text) return text;
    return text
      .split(' ')
      .map(word => {
        if (word.length === 0) return word;
        // If word is already in uppercase, keep it as is
        if (word === word.toUpperCase() && word.length > 1) return word;
        // Otherwise capitalize first letter only, preserve rest of the word as typed
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    const capitalizedValue = capitalizeAllWords(value);
    setdescription(capitalizedValue);
  };


  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await axios.get(BASE_URL + 'productGroup/findAllProductGroup', {
          headers: authHeader(),
        });
        setgroupOptions(response.data.map(group => ({ value: group.id, label: group.groupname })));
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch group. Please try again.',
        });
      }
    };
    fetchGroups();
  }, []);

  const handlegroupChange = async (selectedOption) => {
    setgroup(selectedOption);
    console.log('selected option', selectedOption);
  };

  useEffect(() => {
    const getcustomerData = async () => {
      try {
        const response = await axios.get(BASE_URL + 'customer/findAllCustomer', {
          headers: authHeader(),
        });
        console.log('customer', response.data);
        setcustomerOptions(response.data.map(customer => ({ value: customer.id, label: customer.companyname })));
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch customer. Please try again.',
        });
      }
    };

    getcustomerData();
  }, [id]);

  const handlecustomerChange = (selectedOption) => {
    setcustomer(selectedOption);
  }
  useEffect(() => {
    const getBrandData = async () => {
      try {
        const response = await axios.get(BASE_URL + 'brand/findAllBrand', {
          headers: authHeader(),
        });
        setBrandOptions(response.data.map(brand => ({ value: brand.id, label: brand.brandname })));
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch brand. Please try again.',
        });
      }
    };

    getBrandData();
  }, [id]);

  const handleBrandChange = (selectedOption) => {
    setBrand(selectedOption);
    setIsBrandSelected(true);

    // Set the product category and category options based on the selected brand
    if (selectedOption.label === "Arai Spares") {
      setproductcategory("Pump Spare"); // Auto-select for Arai Spares
      setCategoryOptions([{ value: "Pump Spare", label: "Pump Spare" }]);
    } else if (selectedOption.label === "Manufacturing") {
      setproductcategory(""); // Reset to allow user selection
      setCategoryOptions([
        { value: "International Manufacturing", label: "International Manufacturing" },
        { value: "Domestic Manufacturing", label: "Domestic Manufacturing" }
      ]);
    } else {
      setproductcategory(''); // Reset if no matching brand
      setCategoryOptions([]); // Reset category options
    }
  };

  const handleIgstChange = (e) => {
    const value = e.target.value;
    setIgst(value);
    const igstValue = parseFloat(value);
    const calculatedCGST = igstValue / 2;
    const calculatedSGST = igstValue / 2;
    setCgst(calculatedCGST.toString());
    setSgst(calculatedSGST.toString());
  };

  const handleFileInputChange = (e, index) => {
    const { files } = e.target;
    const updatedFileInputs = [...fileInputs];
    updatedFileInputs[index] = files[0];
    setFileInputs(updatedFileInputs);
  };

  const handleAddFileInput = () => {
    setFileInputs([...fileInputs, null]);
  };

  const handleRemoveFileInput = (index) => {
    const updatedFileInputs = [...fileInputs];
    updatedFileInputs.splice(index, 1);
    setFileInputs(updatedFileInputs);
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    const formData = new FormData();

    // Append product details to FormData
    formData.append('product', JSON.stringify({
      productcategory,
      customer: customer ? { id: customer.value } : null,
      brand: brand ? { id: brand.value } : null,
      productGroup: group ? { id: group.value } : null,
      description,
      hsnsacno,
      igst,
      cgst,
      sgst,
      itemcode,
      producttype,
      unitofmeasurement,
      customername,
      partno,
      labourcharges,
      moc,
      modelnumber,
      serialnumber,
      tagnumber,
      outsidedia,
      wallthickness,
      innerdia,
      hardness,
      make,
      size,
      schedule,
      rating,
      classes,
      rating
    }));

    // Append files to FormData, even if there are none
    if (fileInputs.length === 0) {
      // If no files are added, append an empty value to ensure the backend knows this field is included
      formData.append('[images]', new Blob([], { type: 'application/octet-stream' }));
    } else {
      fileInputs.forEach((file) => {
        if (file) {
          formData.append('[images]', file); // 'images[]' allows for multiple files
        }
      });
    }

    try {
      const response = await axios.post(`${BASE_URL}product/save`, formData, {
        headers: authHeader(),
        'Content-Type': 'multipart/form-data'
      });
      console.log(' API Add product', response.data);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Product added successfully!',
      });

      navigate('/productindex/1');
    } catch (error) {
      let errorMessage = 'An unexpected error occurred. Please try again.';

      if (error.response) {
        if (error.response.status === 400) {
          errorMessage = error.response.data;
        } else if (error.response.status === 401) {
          errorMessage = 'Either select the file or remove the choose file option.';
        } else {
          errorMessage = error.response.data.message || 'Something went wrong. Please try again.';
        }
      } else if (error.request) {
        errorMessage = 'No response from the server. Please check your network connection.';
      }

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (productcategory === "Pump Spare" && !hsnsacno) {
      setHsnsacno("84139190");
    }
  }, [productcategory]);


  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD PRODUCT</h6>
          <Link to="/productindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              {/* Brand */}
              <Col md="6">
                <Form.Group controlId="formbrand">
                  <Form.Label>Brand</Form.Label>
                  <Select
                    value={brand}
                    onChange={handleBrandChange}
                    options={brandOptions}
                    placeholder="Select Brand"
                    isDisabled={isBrandSelected}
                  />
                </Form.Group>
              </Col>

              {/* Product Category */}
              <Col md="6">
                <Form.Group controlId="formproductcategory">
                  <Form.Label>Product Category</Form.Label>
                  <Form.Select
                    value={productcategory}
                    onChange={(e) => setproductcategory(e.target.value)}
                  >
                    <option value="">Select Product Category</option>
                    {categoryOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Stock Group */}
              <Col md="6">
                <Form.Group controlId="formgroup">
                  <Form.Label>Stock Group</Form.Label>
                  <Select
                    value={group}
                    onChange={handlegroupChange}
                    options={groupOptions}
                    placeholder="Select group"
                  />
                </Form.Group>
              </Col>
              {/* Product Type */}
              <Col md="6">
                <Form.Group controlId="formproducttype">
                  <Form.Label>Product Type</Form.Label>
                  <Form.Select
                    value={producttype}
                    onChange={(e) => setproducttype(e.target.value)}
                  >
                    <option value="">Select Product Type</option>
                    {(productcategory === "Pump Spare"
                      ? allProductTypes.filter(type => type.value !== "Raw Material" && type.value !== "Semi Finished")
                      : allProductTypes
                    ).map(type => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* PUMP  SPAIRS   */}
              {(productcategory === "Pump Spare") && (
                <>
                  <Col md="12">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Product Description</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formbrand">
                      <Form.Label>Customer Name</Form.Label>
                      <Select
                        value={customer}
                        onChange={handlecustomerChange}
                        options={customerOptions}
                        placeholder="Select customer"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Model Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={modelnumber}
                        onChange={(e) => setmodelnumber(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Tag Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={tagnumber}
                        onChange={(e) => settagnumber(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Item Code</Form.Label>
                      <Form.Control
                        type="text"
                        value={itemcode}
                        onChange={(e) => setitemcode(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={hsnsacno}
                        onChange={(e) => setHsnsacno(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Serial Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={serialnumber}
                        onChange={(e) => setserialnumber(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formmoc">
                      <Form.Label>MOC</Form.Label>
                      <Form.Control
                        type="text"
                        value={moc}
                        onChange={(e) => setmoc(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>Part No</Form.Label>
                      <Form.Control
                        type="text"
                        value={partno}
                        onChange={(e) => setPartno(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formproducttype">
                      <Form.Label>Unit Of Measurement</Form.Label>
                      <Form.Select value={unitofmeasurement}
                        onChange={(e) => {
                          setunitofmeasurement(e.target.value);
                        }}
                      >
                        <option>Select Unit Of Measurement</option>
                        <option value="bot">Bot</option>
                        <option value="ctn">Ctn</option>
                        <option value="days">Days</option>
                        <option value="ft">Ft</option>
                        <option value="hrs">Hrs</option>
                        <option value="kg">Kg</option>
                        <option value="grams">Grams</option>
                        <option value="ltr">Ltr</option>
                        <option value="mtr">Mtr</option>
                        <option value="nos">Nos</option>
                        <option value="pil">Pil</option>
                        <option value="pkt">Pkt</option>
                        <option value="set">Set</option>
                        <option value="pcs">Pcs</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formigst">
                      <Form.Label>IGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={igst}
                        onChange={handleIgstChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formcgst">
                      <Form.Label>CGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={cgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formsgst">
                      <Form.Label>SGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={sgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </>
              )}
              {/*International Manufacturing */}
              {(productcategory === "International Manufacturing" && producttype === "Finished") && (
                <>
                  <Col md="12">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Product Description</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formbrand">
                      <Form.Label>Customer Name</Form.Label>
                      <Select
                        value={customer}
                        onChange={handlecustomerChange}
                        options={customerOptions}
                        placeholder="Select customer"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Model Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={modelnumber}
                        onChange={(e) => setmodelnumber(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Tag Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={tagnumber}
                        onChange={(e) => settagnumber(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Item Code</Form.Label>
                      <Form.Control
                        type="text"
                        value={itemcode}
                        onChange={(e) => setitemcode(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={hsnsacno}
                        onChange={(e) => setHsnsacno(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Serial Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={serialnumber}
                        onChange={(e) => setserialnumber(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formmoc">
                      <Form.Label>MOC</Form.Label>
                      <Form.Control
                        type="text"
                        value={moc}
                        onChange={(e) => setmoc(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>Part No</Form.Label>
                      <Form.Control
                        type="text"
                        value={partno}
                        onChange={(e) => setPartno(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>


                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>labour Charges (%)</Form.Label>
                      <Form.Control
                        type="number"
                        id="labourcharges"
                        name="labourcharges"
                        value={labourcharges || ''}
                        onChange={(e) => setlabourcharges(e.target.value)}
                        className="form-control"
                        placeholder="Enter labour charges percentage"
                      />
                    </Form.Group>
                  </Col>


                  <Col md="6">
                    <Form.Group controlId="formproducttype">
                      <Form.Label>Unit Of Measurement</Form.Label>
                      <Form.Select value={unitofmeasurement}
                        onChange={(e) => {
                          setunitofmeasurement(e.target.value);
                        }}
                      >
                        <option>Select Unit Of Measurement</option>
                        <option value="bot">Bot</option>
                        <option value="ctn">Ctn</option>
                        <option value="days">Days</option>
                        <option value="ft">Ft</option>
                        <option value="hrs">Hrs</option>
                        <option value="kg">Kg</option>
                        <option value="grams">Grams</option>
                        <option value="ltr">Ltr</option>
                        <option value="mtr">Mtr</option>
                        <option value="nos">Nos</option>
                        <option value="pil">Pil</option>
                        <option value="pkt">Pkt</option>
                        <option value="set">Set</option>
                        <option value="pcs">Pcs</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formigst">
                      <Form.Label>IGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={igst}
                        onChange={handleIgstChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formcgst">
                      <Form.Label>CGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={cgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formsgst">
                      <Form.Label>SGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={sgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </>
              )}


              {/* Manufacturing / Raw Material fields (visible for Domestic Manufacturing, International Manufacturing, Raw Material, and Semi Finished) */}


              {(productcategory === "International Manufacturing" && producttype === "Raw Material") && (

                <>
                  <Col md="12">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Product Description</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formmoc">
                      <Form.Label>MOC</Form.Label>
                      <Form.Control
                        type="text"
                        value={moc}
                        onChange={(e) => setmoc(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Size</Form.Label>
                      <Form.Control
                        type="text"
                        value={size}
                        onChange={(e) => setsize(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>Part No</Form.Label>
                      <Form.Control
                        type="text"
                        value={partno}
                        onChange={(e) => setPartno(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={hsnsacno}
                        onChange={(e) => setHsnsacno(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Schedule</Form.Label>
                      <Form.Control
                        type="text"
                        value={schedule}
                        onChange={(e) => setschedule(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Class</Form.Label>
                      <Form.Control
                        type="text"
                        value={classes}
                        onChange={(e) => setclasses(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formproducttype">
                      <Form.Label>Unit Of Measurement</Form.Label>
                      <Form.Select value={unitofmeasurement}
                        onChange={(e) => {
                          setunitofmeasurement(e.target.value);
                        }}
                      >
                        <option>Select Unit Of Measurement</option>
                        <option value="bot">Bot</option>
                        <option value="ctn">Ctn</option>
                        <option value="days">Days</option>
                        <option value="ft">Ft</option>
                        <option value="hrs">Hrs</option>
                        <option value="kg">Kg</option>
                        <option value="grams">Grams</option>
                        <option value="ltr">Ltr</option>
                        <option value="mtr">Mtr</option>
                        <option value="nos">Nos</option>
                        <option value="pil">Pil</option>
                        <option value="pkt">Pkt</option>
                        <option value="set">Set</option>
                        <option value="pcs">Pcs</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formigst">
                      <Form.Label>IGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={igst}
                        onChange={handleIgstChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formcgst">
                      <Form.Label>CGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={cgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formsgst">
                      <Form.Label>SGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={sgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </>
              )}

              {/* Semi Finished fields */}
              {(productcategory === "International Manufacturing" && producttype === "Semi Finished") && (
                <>
                  <Col md="12">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Product Description</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Item Code</Form.Label>
                      <Form.Control
                        type="text"
                        value={itemcode}
                        onChange={(e) => setitemcode(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formmoc">
                      <Form.Label>MOC</Form.Label>
                      <Form.Control
                        type="text"
                        value={moc}
                        onChange={(e) => setmoc(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Size</Form.Label>
                      <Form.Control
                        type="text"
                        value={size}
                        onChange={(e) => setsize(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={hsnsacno}
                        onChange={(e) => setHsnsacno(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Schedule</Form.Label>
                      <Form.Control
                        type="text"
                        value={schedule}
                        onChange={(e) => setschedule(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Class</Form.Label>
                      <Form.Control
                        type="text"
                        value={classes}
                        onChange={(e) => setclasses(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Rating</Form.Label>
                      <Form.Control
                        type="text"
                        value={rating}
                        onChange={(e) => setrating(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Type</Form.Label>
                      <Form.Control
                        type="text"
                        value={type}
                        onChange={(e) => settype(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formproducttype">
                      <Form.Label>Unit Of Measurement</Form.Label>
                      <Form.Select value={unitofmeasurement}
                        onChange={(e) => {
                          setunitofmeasurement(e.target.value);
                        }}
                      >
                        <option>Select Unit Of Measurement</option>
                        <option value="bot">Bot</option>
                        <option value="ctn">Ctn</option>
                        <option value="days">Days</option>
                        <option value="ft">Ft</option>
                        <option value="hrs">Hrs</option>
                        <option value="kg">Kg</option>
                        <option value="grams">Grams</option>
                        <option value="ltr">Ltr</option>
                        <option value="mtr">Mtr</option>
                        <option value="nos">Nos</option>
                        <option value="pil">Pil</option>
                        <option value="pkt">Pkt</option>
                        <option value="set">Set</option>
                        <option value="pcs">Pcs</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formigst">
                      <Form.Label>IGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={igst}
                        onChange={handleIgstChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formcgst">
                      <Form.Label>CGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={cgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formsgst">
                      <Form.Label>SGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={sgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </>
              )}

              {/* MANUFACTURING DOMESTIC  */}

              {(productcategory === "Domestic Manufacturing" && producttype === "Finished") && (
                <>
                  <Col md="12">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Product Description</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formbrand">
                      <Form.Label>Customer Name</Form.Label>
                      <Select
                        value={customer}
                        onChange={handlecustomerChange}
                        options={customerOptions}
                        placeholder="Select customer"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Model Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={modelnumber}
                        onChange={(e) => setmodelnumber(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Tag Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={tagnumber}
                        onChange={(e) => settagnumber(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>Part No</Form.Label>
                      <Form.Control
                        type="text"
                        value={partno}
                        onChange={(e) => setPartno(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Item Code</Form.Label>
                      <Form.Control
                        type="text"
                        value={itemcode}
                        onChange={(e) => setitemcode(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={hsnsacno}
                        onChange={(e) => setHsnsacno(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Serial Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={serialnumber}
                        onChange={(e) => setserialnumber(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formmoc">
                      <Form.Label>MOC</Form.Label>
                      <Form.Control
                        type="text"
                        value={moc}
                        onChange={(e) => setmoc(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>labour Charges (%)</Form.Label>
                      <Form.Control
                        type="number"
                        id="labourcharges"
                        name="labourcharges"
                        value={labourcharges || ''}
                        onChange={(e) => setlabourcharges(e.target.value)}
                        className="form-control"
                        placeholder="Enter labour charges percentage"
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formproducttype">
                      <Form.Label>Unit Of Measurement</Form.Label>
                      <Form.Select value={unitofmeasurement}
                        onChange={(e) => {
                          setunitofmeasurement(e.target.value);
                        }}
                      >
                        <option>Select Unit Of Measurement</option>
                        <option value="bot">Bot</option>
                        <option value="ctn">Ctn</option>
                        <option value="days">Days</option>
                        <option value="ft">Ft</option>
                        <option value="hrs">Hrs</option>
                        <option value="kg">Kg</option>
                        <option value="grams">Grams</option>
                        <option value="ltr">Ltr</option>
                        <option value="mtr">Mtr</option>
                        <option value="nos">Nos</option>
                        <option value="pil">Pil</option>
                        <option value="pkt">Pkt</option>
                        <option value="set">Set</option>
                        <option value="pcs">Pcs</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formigst">
                      <Form.Label>IGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={igst}
                        onChange={handleIgstChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formcgst">
                      <Form.Label>CGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={cgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formsgst">
                      <Form.Label>SGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={sgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </>
              )}


              {(productcategory === "Domestic Manufacturing" && producttype === "Raw Material") && (

                <>
                  <Col md="12">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Product Description</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formmoc">
                      <Form.Label>MOC</Form.Label>
                      <Form.Control
                        type="text"
                        value={moc}
                        onChange={(e) => setmoc(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Size</Form.Label>
                      <Form.Control
                        type="text"
                        value={size}
                        onChange={(e) => setsize(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>Part No</Form.Label>
                      <Form.Control
                        type="text"
                        value={partno}
                        onChange={(e) => setPartno(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Schedule</Form.Label>
                      <Form.Control
                        type="text"
                        value={schedule}
                        onChange={(e) => setschedule(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={hsnsacno}
                        onChange={(e) => setHsnsacno(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Class</Form.Label>
                      <Form.Control
                        type="text"
                        value={classes}
                        onChange={(e) => setclasses(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formproducttype">
                      <Form.Label>Unit Of Measurement</Form.Label>
                      <Form.Select value={unitofmeasurement}
                        onChange={(e) => {
                          setunitofmeasurement(e.target.value);
                        }}
                      >
                        <option>Select Unit Of Measurement</option>
                        <option value="bot">Bot</option>
                        <option value="ctn">Ctn</option>
                        <option value="days">Days</option>
                        <option value="ft">Ft</option>
                        <option value="hrs">Hrs</option>
                        <option value="kg">Kg</option>
                        <option value="grams">Grams</option>
                        <option value="ltr">Ltr</option>
                        <option value="mtr">Mtr</option>
                        <option value="nos">Nos</option>
                        <option value="pil">Pil</option>
                        <option value="pkt">Pkt</option>
                        <option value="set">Set</option>
                        <option value="pcs">Pcs</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formigst">
                      <Form.Label>IGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={igst}
                        onChange={handleIgstChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formcgst">
                      <Form.Label>CGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={cgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formsgst">
                      <Form.Label>SGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={sgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </>
              )}

              {/* Semi Finished fields */}
              {(productcategory === "Domestic Manufacturing" && producttype === "Semi Finished") && (
                <>
                  <Col md="12">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Product Description</Form.Label>
                      <Form.Control
                        type="text"
                        value={description}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formdescription">
                      <Form.Label>Item Code</Form.Label>
                      <Form.Control
                        type="text"
                        value={itemcode}
                        onChange={(e) => setitemcode(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formmoc">
                      <Form.Label>MOC</Form.Label>
                      <Form.Control
                        type="text"
                        value={moc}
                        onChange={(e) => setmoc(e.target.value.toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Size</Form.Label>
                      <Form.Control
                        type="text"
                        value={size}
                        onChange={(e) => setsize(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formpartno">
                      <Form.Label>Part No</Form.Label>
                      <Form.Control
                        type="text"
                        value={partno}
                        onChange={(e) => setPartno(e.target.value.toUpperCase())}

                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>HSN Code</Form.Label>
                      <Form.Control
                        type="number"
                        value={hsnsacno}
                        onChange={(e) => setHsnsacno(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Schedule</Form.Label>
                      <Form.Control
                        type="text"
                        value={schedule}
                        onChange={(e) => setschedule(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Class</Form.Label>
                      <Form.Control
                        type="text"
                        value={classes}
                        onChange={(e) => setclasses(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Rating</Form.Label>
                      <Form.Control
                        type="text"
                        value={rating}
                        onChange={(e) => setrating(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="6">
                    <Form.Group controlId="formhsnsacno">
                      <Form.Label>Type</Form.Label>
                      <Form.Control
                        type="text"
                        value={type}
                        onChange={(e) => settype(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formproducttype">
                      <Form.Label>Unit Of Measurement</Form.Label>
                      <Form.Select value={unitofmeasurement}
                        onChange={(e) => {
                          setunitofmeasurement(e.target.value);
                        }}
                      >
                        <option>Select Unit Of Measurement</option>
                        <option value="bot">Bot</option>
                        <option value="ctn">Ctn</option>
                        <option value="days">Days</option>
                        <option value="ft">Ft</option>
                        <option value="hrs">Hrs</option>
                        <option value="kg">Kg</option>
                        <option value="grams">Grams</option>
                        <option value="ltr">Ltr</option>
                        <option value="mtr">Mtr</option>
                        <option value="nos">Nos</option>
                        <option value="pil">Pil</option>
                        <option value="pkt">Pkt</option>
                        <option value="set">Set</option>
                        <option value="pcs">Pcs</option>

                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formigst">
                      <Form.Label>IGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={igst}
                        onChange={handleIgstChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formcgst">
                      <Form.Label>CGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={cgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formsgst">
                      <Form.Label>SGST</Form.Label>
                      <Form.Control
                        type="number"
                        value={sgst}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </>
              )}

              {/* end */}

              <Col md="6">
                <Form.Group controlId="formfiles">
                  <Form.Label>Upload Images or PDFs</Form.Label>
                  {fileInputs.map((file, index) => (
                    <div key={index} className="mb-2">
                      <Form.Control
                        type="file"
                        accept="image/*,.pdf"
                        onChange={(e) => handleFileInputChange(e, index)}
                      />
                      <button
                        type="button"
                        className="btn btn-link text-danger"
                        onClick={() => handleRemoveFileInput(index)}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  <button
                    style={{ marginBottom: '10px' }}
                    type="button"
                    className="btn btn-secondary add-file"
                    onClick={handleAddFileInput}
                  >
                    Add File
                  </button>
                </Form.Group>
              </Col>
            </Row>
            <button className="button-70" type="button" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? <Spinner animation="border" size="sm" /> : 'SUBMIT'}
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProductCreate;